// extracted by mini-css-extract-plugin
export default {"buttons":"DeleteProductModal_buttons__VgwwX","errorMessage":"DeleteProductModal_errorMessage__gnKGQ"};